import { render, staticRenderFns } from "./DraggableLists.vue?vue&type=template&id=4d10f7c8&scoped=true&"
import script from "./DraggableLists.vue?vue&type=script&lang=js&"
export * from "./DraggableLists.vue?vue&type=script&lang=js&"
import style0 from "./DraggableLists.vue?vue&type=style&index=0&id=4d10f7c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d10f7c8",
  null
  
)

export default component.exports